import React, { useContext, ReactNode } from 'react';
import { Route } from 'react-router-dom';

import SubNavigation from 'components/SubNavigation/SubNavigation';
import Radio from './Radio';
import Discoveries from './Discoveries';

import { airplaySubTopics } from 'topics';
import { IEntityPageComponentProps } from 'pages/Entity/shared';
import TopicFilters from 'components/TopicFilters/TopicFilters';
import { EntityContext } from 'context/entityContext';

const Airplay: React.FC<IEntityPageComponentProps> = (props) => {
  const { match, pathPrefix } = props;
  const { entityId } = match.params;

  const { compareMode, topic } = useContext(EntityContext);

  return (
    <>
      <SubNavigation topic="airplay" variants={airplaySubTopics} />
      <TopicFilters topic={topic[1] || topic[0]} compareMode={compareMode} />

      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/airplay/radio`}
        render={(): ReactNode => <Radio />}
      />
      <Route
        exact
        path={`${pathPrefix}/track/${entityId}/airplay/discoveries`}
        render={(): ReactNode => <Discoveries />}
      />
    </>
  );
};

export default Airplay;
